import { api } from './client';

export interface BankAccountDto {
  id: number;
  name: string;
  iban: string;
  bankName: string;
  bankCode: string;
  currencyCode: string;
  accountType: string;
  glAccountNumber: number;
  isObsolete: boolean;
  insertDate: string;
  updateDate: string;
}

export interface BankAccountBalanceDto {
  bankAccountId: number;
  bankAccountName?: string;
  glAccountNumber: number;
  currencyCode: string;
  totalDebit: number;
  totalCredit: number;
  netBalance: number;
  asOfDate: string;
}

export interface BankStatementDto {
  bankAccountId: number;
  bankAccountName: string;
  iban: string;
  currencyCode: string;
  periodFrom: string;
  periodTo: string;
  openingBalance: number;
  periodDebit: number;
  periodCredit: number;
  periodNet: number;
  closingBalance: number;
  transactions: BankStatementLineDto[];
}

export interface BankStatementLineDto {
  id: number;
  date: string;
  documentNumber: string;
  debit: number;
  credit: number;
  currencyCode: string;
  personId: number | null;
}

export interface CreateBankAccountRequest {
  name: string;
  iban?: string;
  bankName?: string;
  bankCode?: string;
  currencyCode?: string;
  accountType: number;
  glAccountNumber: number;
}

export interface UpdateBankAccountRequest extends CreateBankAccountRequest {
  isObsolete: boolean;
}

export const bankAccountsApi = {
  list: (params: { accountType?: string } = {}) =>
    api.get<BankAccountDto[]>('/bank-accounts', params),

  getById: (id: number) =>
    api.get<BankAccountDto>(`/bank-accounts/${id}`),

  create: (data: CreateBankAccountRequest) =>
    api.post<number>('/bank-accounts', data),

  update: (id: number, data: UpdateBankAccountRequest) =>
    api.put<void>(`/bank-accounts/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/bank-accounts/${id}`),

  getBalance: (id: number, asOf?: string) =>
    api.get<BankAccountBalanceDto>(`/bank-accounts/${id}/balance`, { asOf }),

  getAllBalances: (asOf?: string) =>
    api.get<BankAccountBalanceDto[]>('/bank-accounts/balances', { asOf }),

  getStatement: (id: number, from: string, to: string) =>
    api.get<BankStatementDto>(`/bank-accounts/${id}/statement`, { from, to }),
};
